var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list && _vm.list.length)?_c('APlayer',{ref:"pl",attrs:{"audio":_vm.list},on:{"listSwitch":_vm.switchOn}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }